<template lang="pug">
  div(v-if="item.contact")

    .flextDriverItem(@click="onClick")
      image-thumbnail.mr-2(v-if="item.contact" :width='90', :height='60', :src="item.contact.thumbnail_id")
      .driverInfo
        div()
          .driverTitle
            |  {{item.contact.first_name}} {{item.contact.last_name}}
          .driverDesc.d-flex.flex-row(v-if="item.avl_record")
            .mr-2(v-if="item.vehicle") {{item.vehicle.name}}
            .driverDesc(v-if="item.avl_record") {{item.avl_record.time | moment("h:mm a - dddd")}}
          .grey--text.caption.d-flex.flex-row(v-if="item.avl_record")
            div() {{getDirection}}
            .mx-4() &nbsp; &ndash; &nbsp;
            .primary--text() {{(item.avl_record.odometer/1000).toFixed(3)}} Km


      .d-flex.flex-column.align-center(v-if="item.avl_record")
        .primary--text.title() {{item.avl_record.speed}}
        .caption() Kph
    v-divider


</template>

<script>
import ImageThumbnail from "@/modules/global/components/forms/ImageThumbnail";
export default {
  components: {
    ImageThumbnail
  },

  props: {
    item: Object,
    status: String
  },
  data: () => ({}),
  methods: {
    onClick:function() {
      if(this.$store.mapTrip != null){
        this.$store.mapTrip.flyTo({
          center: [this.item.avl_record.location.lon,this.item.avl_record.location.lat],
          essential:true,
        })
      }

    }
  },
  computed: {


    getDirection: function() {
      let direction = "";
      if (this.item && this.item.avl_record) {
        let angle = this.item.avl_record.angle;
        if (angle > 360) {
          angle = angle % 360;
        }

        if (angle < 22.5) {
          direction = "North";
        } else if (angle > 22.5 && angle <= 67.5) {
          direction = "North East";
        } else if (angle > 67.5 && angle < 111.5) {
          direction = "East";
        } else if (angle >= 111.5 && angle <= 157) {
          direction = "South East";
        } else if (angle > 157 && angle < 202.5) {
          direction = "South";
        } else if (angle >= 202.5 && angle <= 247.5) {
          direction = "South West";
        } else if (angle > 247.5 && angle < 292.5) {
          direction = "West";
        } else if (angle >= 292.5 && angle <= 337.5) {
          direction = "North West";
        } else if (angle > 337.5) {
          direction = "North";
        }

        return direction;
      } else {
        return direction;
      }
    }
  }
};
</script>

<style scoped>
.flextDriverItem {
  display: flex;
  flex-direction: row;
  padding: 8px 15px 15px 15px;
}

.flextDriverItem:hover {
  cursor: pointer;
  background-color: #E8E8E8;
}


.driverInfo {
  padding-left: 12px;
  padding-right: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.driverTitle {
  font-size: 13px;
  font-weight: Bold;
}

.driverDesc {
  font-size: 12px;
}

.driverDirection {
  font-size: 12px;
  font-weight: lighter;
}

.status {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.statusIcon {
  margin-top: -2px;
  margin-left: 1px;
  font-size: 130%;
}

.numberPlate {
  font-weight: lighter;
}
</style>
